__turbopack_context__.v({
  "markdown": "markdown-styles-module__JGUXpq__markdown",
});
